import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { 
  PendingActions, 
  Inventory2, 
  Numbers 
} from "@mui/icons-material";

const StatCard = ({ title, value, icon, color = "#FF7322" }) => (
  <Card
    sx={{
      flex: 1,
      minWidth: 200,
      backgroundColor: "white",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      borderRadius: 1,
      border: "1px solid rgba(0,0,0,0.1)",
      transition: "all 0.3s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
      }
    }}
  >
    <CardContent sx={{ p: 2.5 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
        <Box sx={{ animation: "pulse 2s infinite" }}>
          {icon}
        </Box>
        <Typography
          variant="subtitle1"
          sx={{
            color: "#666",
            fontWeight: 600
          }}
        >
          {title}
        </Typography>
      </Box>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: color,
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "scale(1.02)"
          }
        }}
      >
        {value}
      </Typography>
    </CardContent>
  </Card>
);

const ExpedicaoStats = ({ totalPendentes, totalItens, totalQuantidade }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        p: 3,
        backgroundColor: "white"
      }}
    >
      <StatCard 
        title="Etiquetas Pendentes" 
        value={totalPendentes} 
        icon={<PendingActions sx={{ color: "#f44336", fontSize: "1.5rem" }} />}
        color="#f44336"
      />
      <StatCard 
        title="Total de Produtos" 
        value={totalItens} 
        icon={<Inventory2 sx={{ color: "#FF7322", fontSize: "1.5rem" }} />}
        color="#FF7322"
      />
      <StatCard 
        title="Quantidade de Itens" 
        value={totalQuantidade} 
        icon={<Numbers sx={{ color: "#4caf50", fontSize: "1.5rem" }} />}
        color="#4caf50"
      />
      
      <style jsx global>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }
      `}</style>
    </Box>
  );
};

export default ExpedicaoStats;